/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/prop-types */
import { CircularProgress, Typography } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CountyContext from '../../contexts/CountyContext';
import StoryContext from '../../contexts/StoryContext';
import { rdsTabulate } from '../../modules/rds';
import { composeWhereClause } from '../../modules/data';
import states, { stateFIPS } from '../../modules/states';
import { toFormattedNumber } from '../../modules/text';
import HorizontalBarChart from '../HorizontalBarChart';
import NoDataVisual from '../NoDataVisual';

function ExposureBySettingType({ height = 300, measure = 'capacity:COUNT(*)' }) {
  const { stateCode } = useParams();
  const [ready, setReady] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const { countyCode, county } = useContext(CountyContext);
  const { primaryColor, secondaryColor } = useContext(StoryContext);

  useEffect(() => {
    setError(null);
    async function getData() {
      setError(null);

      // const server = new RdsServer(process.env.REACT_APP_RDS_SERVER);
      // Instantiate a catalog that exists on the server
      // const catalog = new RdsCatalog(server, 'ccdc');
      // Instantiate a data product that exists on the catalog
      // const dataProduct = new RdsDataProduct(catalog, 'county_licensed_capacity');
      let whereClause = `state_fips=${stateFIPS[stateCode.toUpperCase()]} AND capacity_type=LIC AND is_near_high_risk_site=1`;
      whereClause += composeWhereClause({});
      if (countyCode) {
        whereClause += ` AND county_fips=${countyCode}`;
      }
      rdsTabulate('ccdc', 'county_licensed_capacity', {
        dims: 'state_fips,setting_type',
        measure,
        where: whereClause,
        format: 'amcharts',
        inject: true,
      })
        .then((result) => {
          const d = result.parsedBody.dataProvider;
          const total = d.reduce((a, v) => (a + Number.parseInt(v.capacity, 10)), 0);
          const payload = d.map((v) => Object.assign(v, { percent: ((v.capacity / total) * 100) }));
          setData(payload);
        })
        .catch((rdsError) => {
          setError(rdsError);
        })
        .finally(() => {
          setReady(true);
        });
    }
    if (stateCode && states[stateCode.toUpperCase()]) {
      // fetch actual average price data
      setReady(false);
      getData();
    }
  }, [stateCode, countyCode, measure]);

  const keys = ['capacity'];
  const groupKey = 'setting_type';

  let title = 'By setting type';
  if (county) {
    title += ` - ${county} County`;
  }

  const tooltipFormatter = function tooltipFormatter(payload) {
    return `${toFormattedNumber(payload.payload.percent)}% are in ${payload.payload.setting_type.toLowerCase()} programs`;
  };

  if (!ready) {
    return <CircularProgress />;
  }

  return (
    <>
      {error && <Typography variant="body1" color="error">{error.message}</Typography>}
      {data && data.length > 0
        && (
          <HorizontalBarChart
            height={height}
            data={data}
            tooltipFormatter={tooltipFormatter}
            valueFormatter={toFormattedNumber}
            keys={keys}
            groupKey={groupKey}
            title={title}
            colors={[primaryColor, secondaryColor]}
            showYTick
          />
        )}

      {(!data || data.length === 0) && <NoDataVisual />}
    </>

  );
}

export default ExposureBySettingType;
